import './index.less';
import Review from './Review';
Review.install = function(Vue) {
  Vue.component(Review.name, Review);
};

export default Review;
